export default __webpack_public_path__ + "static/media/douglas-lopes.0dcc1a36.jpg";